import React, { useEffect, useRef, useState, useCallback } from "react"
import "./InstitutionDataTable.scss"
import { useNavigate } from "react-router-dom"
import InstituteApi from "Api/InstituteApi"
import LogsApi from "Api/LogsApi"
import { OverlayPanel } from "primereact/overlaypanel"
import { Menu } from "primereact/menu"
import {
  Button,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Spinner,
  Table,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import DataTableLoader from "SkeletonLoader/DataTableLoader"
import { Toast } from "primereact/toast"
import LogsSidebar from "components/LogsSidebar/LogsSidebar"
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import { Accordion, AccordionTab } from "primereact/accordion"

const InstitutionDataTable = () => {
  document.title = "Institution"
  const navigate = useNavigate("")
  const op = useRef(null)
  const os = useRef(null)
  const excelMenuRef = useRef(null)
  const uploadbtn = useRef()
  const accessToken = localStorage.getItem("accessToken")
  const [instituteDetails, setInstituteDetails] = useState([])
  const userData = JSON.parse(localStorage.getItem("userData"))
  const [filteredInstitutionDetails, setFilteredInstitutionDetails] = useState([])
  const toast = useRef(null)
  const [selectedLogo, setSelectedLogo] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [logsVisible, setLogsVisible] = useState(false)
  const [logs, setLogs] = useState([])
  const [logsLoading, setLogsLoading] = useState(false)

  const [page, setPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [limit, setLimit] = useState(10)
  const [filterStatus, setFilterStatus] = useState("all")
  const [filterCategory, setFilterCategory] = useState("all")

  const breadcrumbItems = [
    { label: "Pixwik", link: "/" },
    { label: "Institution", link: "#" },
    { label: "Institution List", link: "#" },
  ]
  const categoryOptions = [
    { name: "Medical", code: "medical" },
    { name: "Engineering", code: "engineering" },
    { name: "Arts & Science", code: "artsAndScience" },
    { name: "Agriculture", code: "agriculture" },
    { name: "Law", code: "law" },
    { name: "Management", code: "management" },
  ]



  const [loading, setLoading] = useState(true)
  const [addInstitutionLoader, setAddInstitutionLoader] = useState(false)

  const [searchQuery, setSearchQuery] = useState("")
  const searchTimeoutRef = useRef(null)

  const [selectedExcelCategory, setSelectedExcelCategory] = useState(null)
  const [excelLoader, setExcelLoader] = useState(false)

  const excelMenuItems = [
    {
      label: "Medical",
      icon: "pi pi-heart",
      command: () => handleExcelUpload("medical"),
    },
    {
      label: "Engineering",
      icon: "pi pi-cog",
      command: () => handleExcelUpload("engineering"),
    },
    {
      label: "Arts & Science",
      icon: "pi pi-book",
      command: () => handleExcelUpload("artsAndScience"),
    },
    {
      label: "Agriculture",
      icon: "pi pi-book",
      command: () => handleExcelUpload("agriculture"),
    },
    {
      label: "Law",
      icon: "pi pi-book",
      command: () => handleExcelUpload("law"),
    },
    {
      label: "Management",
      icon: "pi pi-book",
      command: () => handleExcelUpload("management"),
    },
  ]

  const handleExcelUploadClick = event => {
    excelMenuRef.current.toggle(event)
  }

  const handleExcelUpload = category => {
    const validCategories = {
      medical: "medical",
      engineering: "engineering",
      artsAndScience: "artsAndScience",
      agriculture: "agriculture",
      law: "law",
      management: "management",
    }

    if (!validCategories[category]) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Invalid category selected",
        life: 3000,
      })
      return
    }

    setSelectedExcelCategory(validCategories[category])
    uploadbtn.current.click()
  }

  const handleFileChange = event => {
    setExcelLoader(true)
    const file = event.target.files[0]
    if (!file) return
    const formData = new FormData()
    formData.append("file", file)
    formData.append("category", selectedExcelCategory)

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    InstituteApi.uploadInstitutionByExcel(formData, config)
      .then(res => {
        getAllInstitutionDetails()
        event.target.value = ""
        setExcelLoader(false)
        setSelectedExcelCategory(null)
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: res.data.message,
          life: 3000,
        })
      })
      .catch(err => {
        event.target.value = ""
        setExcelLoader(false)
        setSelectedExcelCategory(null)
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: err.response?.data?.message || "Failed to upload file",
          life: 3000,
        })
      })
  }

  const menuRef = useRef(null)

  const menuItems = [
    {
      label: "Medical",
      icon: "pi pi-heart",
      command: () => navigate("/addInstituion", { state: { type: "medical" } }),
    },
    {
      label: "Engineering",
      icon: "pi pi-cog",
      command: () =>
        navigate("/addInstituion", { state: { type: "engineering" } }),
    },
    {
      label: "Arts & Science",
      icon: "pi pi-book",
      command: () =>
        navigate("/addInstituion", { state: { type: "artsAndScience" } }),
    },
    {
      label: "Agriculture",
      icon: "pi pi-book",
      command: () =>
        navigate("/addInstituion", { state: { type: "agriculture" } }),
    },
    {
      label: "Law",
      icon: "pi pi-book",
      command: () => navigate("/addInstituion", { state: { type: "law" } }),
    },
    {
      label: "Management",
      icon: "pi pi-book",
      command: () =>
        navigate("/addInstituion", { state: { type: "management" } }),
    },
  ]

  const handleAddInstitutionClick = event => {
    menuRef.current.toggle(event)
  }

  const [selectedInstitutions, setSelectedInstitutions] = useState([])

  const toggleSelectAll = () => {
    if (selectedInstitutions.length === filteredInstitutionDetails.length) {
      setSelectedInstitutions([])
    } else {
      setSelectedInstitutions(filteredInstitutionDetails.map(inst => inst._id))
    }
  }

  const toggleSelection = instId => {
    setSelectedInstitutions(prevInst =>
      prevInst.includes(instId)
        ? prevInst.filter(id => id !== instId)
        : [...prevInst, instId],
    )
  }

  const handleUpdateStatus = async newStatus => {
    if (selectedInstitutions.length === 0) {
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "Please select at least one Institution to update.",
        life: 3000,
      })
      return
    }

    try {
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }

      // Get all selected institutions
      const selectedInstitutionDetails = instituteDetails.filter(inst =>
        selectedInstitutions.includes(inst._id),
      )

      if (selectedInstitutionDetails.length === 0) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Selected institutions not found",
          life: 3000,
        })
        return
      }

      // Update each institution one by one
      const updatePromises = selectedInstitutionDetails.map(institution => {
        const payload = {
          institutionIds: [institution._id],
          newStatus: newStatus === "approve" ? "approved" : "rejected",
          category: institution.category.toLowerCase(),
        }
        return InstituteApi.updateInstitutionStatus(payload, config)
      })

      const results = await Promise.all(updatePromises)

      // Check if all updates were successful
      const allSuccessful = results.every(response => response.data.status)

      if (allSuccessful) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Institutions updated successfully",
          life: 3000,
        })
        getAllInstitutionDetails()
        setSelectedInstitutions([])
      } else {
        // If some updates failed
        const failedCount = results.filter(
          response => !response.data.status,
        ).length
        toast.current.show({
          severity: "warn",
          summary: "Partial Success",
          detail: `${failedCount} institution(s) failed to update`,
          life: 3000,
        })
        getAllInstitutionDetails()
        setSelectedInstitutions([])
      }
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail:
          error.response?.data?.message ||
          "Failed to update Institution status",
        life: 3000,
      })
    }
  }

  const uniqueCategories = [
    ...new Set(instituteDetails?.map(inst => inst.category)),
  ]

  const toggleLogoModal = (logoUrl = null) => {
    setSelectedLogo(logoUrl)
    setIsModalOpen(!isModalOpen)
  }

  const debouncedSearch = useCallback(
    query => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current)
      }

      searchTimeoutRef.current = setTimeout(async () => {
        if (!query || query.trim() === "") {
          getAllInstitutionDetails()
          return
        }

        const config = {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            query: query,
            limit: limit,
            page: page,
          },
        }

        try {
          const response = await InstituteApi.searchInstitution(config)
          if (response.data.status) {
            setInstituteDetails(response.data.results || [])
            setFilteredInstitutionDetails(response.data.results || [])
            setTotalRecords(response.data.totalRecords || (response.data.results || []).length)
          } else {
            setInstituteDetails([])
            setFilteredInstitutionDetails([])
            setTotalRecords(0)
            toast.current.show({
              severity: "info",
              summary: "No Results",
              detail:
                response.data.message ||
                "No institutions found matching your search",
              life: 3000,
            })
          }
        } catch (error) {
          setInstituteDetails([])
          setFilteredInstitutionDetails([])
          setTotalRecords(0)
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail:
              error.response?.data?.message || "Failed to search institutions",
            life: 3000,
          })
        }
      }, 800)
    },
    [accessToken, page, limit],
  )

  const handleSearch = e => {
    const value = e.target.value
    setSearchQuery(value)
    setPage(1) // Reset to first page when searching
    debouncedSearch(value)
  }

  // Update useEffect to handle search pagination
  useEffect(() => {
    if (searchQuery.trim() !== "") {
      debouncedSearch(searchQuery)
    } else {
      getAllInstitutionDetails()
    }
  }, [page, limit, searchQuery])

  const [allLogs, setAllLogs] = useState([])

  const fetchLogs = async () => {
    setLogsLoading(true)
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
      const response = await LogsApi.getLogsByServiceName(
        "institution-service",
        config,
      )
      // Sort logs by timestamp in descending order
      const sortedLogs = response.data.logs.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
      )
      setAllLogs(sortedLogs)
      setLogs(sortedLogs)
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch logs",
        life: 3000,
      })
    } finally {
      setLogsLoading(false)
    }
  }

  const handleLogsClick = () => {
    setLogsVisible(true)
    fetchLogs()
  }

  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current)
      }
    }
  }, [])

  const getLogLevelClass = eventType => {
    const type = eventType.toLowerCase()
    switch (type) {
      case "error":
        return "bg-danger"
      case "warning":
        return "bg-warning text-dark"
      case "info":
        return "bg-info text-dark"
      case "debug":
        return "bg-secondary"
      default:
        return "bg-primary"
    }
  }

  const LogHeader = log => {
    return (
      <div className="d-flex justify-content-between align-items-center w-100">
        <div className="d-flex align-items-center gap-2">
          <span
            className={`event-type badge ${getLogLevelClass(log.eventType)}`}
          >
            {log.eventType}
          </span>
          <span className="timestamp text-muted">
            {new Date(log.createdAt).toLocaleString()}
          </span>
        </div>
        <div className="message">{log.message}</div>
      </div>
    )
  }

  const handleFilterChange = level => {
    if (level === "all") {
      setLogs(allLogs)
    } else {
      setLogs(allLogs.filter(log => log.eventType.toLowerCase() === level))
    }
  }

  const handleUploadButtonClick = () => {
    uploadbtn.current.click()
  }

  const getAllInstitutionDetails = () => {
    setLoading(true)

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        limit: limit,
        page: page,
      },
    }

    InstituteApi.getAllInstitutions(config)
      .then(response => {
        setLoading(false)
        setInstituteDetails(response.data.institutions || [])
        setFilteredInstitutionDetails(response.data.institutions || [])
        setTotalRecords(response.data.totalRecords || 0)
      })
      .catch(error => {
        setLoading(false)
        setInstituteDetails([])
        setFilteredInstitutionDetails([])
        setTotalRecords(0)
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: error.response?.data?.message || "Failed to fetch institutions",
          life: 3000,
        })
      })
  }

  useEffect(() => {
    getAllInstitutionDetails()
  }, [accessToken, page, limit])

  useEffect(() => {
    let filteredData = instituteDetails || []

    if (filterStatus !== "all") {
      filteredData = filteredData.filter(
        institution => institution.verifiedStatus === filterStatus,
      )
    }

    if (filterCategory !== "all") {
      filteredData = filteredData.filter(
        institution => institution.category === filterCategory,
      )
    }

    setFilteredInstitutionDetails(filteredData)
  }, [filterStatus, filterCategory, instituteDetails])

  const totalPages = Math.ceil(totalRecords / limit)

  return (
    <div className="institution-data-table">
      <Toast ref={toast} />
      <Menu
        model={menuItems}
        popup
        ref={menuRef}
        appendTo="self"
        autoZIndex
        baseZIndex={1000}
      />
      <Menu
        model={excelMenuItems}
        popup
        ref={excelMenuRef}
        appendTo="self"
        autoZIndex
        baseZIndex={1000}
      />
      <LogsSidebar
        visible={logsVisible}
        onHide={() => setLogsVisible(false)}
        logs={logs}
        loading={logsLoading}
        onRefresh={fetchLogs}
        onFilterChange={handleFilterChange}
        allLogs={allLogs}
      />
      <Modal
        isOpen={isModalOpen}
        toggle={() => toggleLogoModal()}
        centered
        size="md"
      >
        <ModalHeader toggle={() => toggleLogoModal()}>
          Institution Logo
        </ModalHeader>
        <ModalBody className="text-center">
          {selectedLogo && (
            <img
              src={selectedLogo}
              alt="Institution Logo"
              style={{ maxWidth: "100%", maxHeight: "500px" }}
            />
          )}
        </ModalBody>
      </Modal>
      <Row>
        <Col xs="12">
          <div className="institution-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Institution" />

            <div className="d-flex align-items-center gap-3">
              {selectedInstitutions.length === 0 && (
                <>
                  <Input
                    type="text"
                    placeholder="Search Institution"
                    className="form-control"
                    style={{ width: "300px" }}
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                  <input
                    type="file"
                    ref={uploadbtn}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                    accept=".xlsx,.xls"
                  />
                  <Button
                    type="button"
                    color="success"
                    className="waves-effect"
                    style={{ minWidth: "40px" }}
                    onClick={handleExcelUploadClick}
                  >
                    {excelLoader ? (
                      <Spinner size="sm" />
                    ) : (
                      <i className="mdi mdi-microsoft-excel" />
                    )}
                  </Button>

                  <Button
                    type="button"
                    color="secondary"
                    className="waves-effect"
                    style={{ minWidth: "120px" }}
                    onClick={handleAddInstitutionClick}
                  >
                    Add Institution
                  </Button>

                  <Button
                    type="button"
                    color="warning"
                    className="waves-effect"
                    style={{ minWidth: "140px" }}
                    onClick={() => navigate("/data-completion")}
                  >
                    <i className="mdi mdi-database-check me-1" />
                    Data Completion
                  </Button>

                  <Button
                    type="button"
                    color="info"
                    className="waves-effect"
                    style={{ minWidth: "100px" }}
                    onClick={handleLogsClick}
                  >
                    <i className="mdi mdi-file-document-outline me-1" />
                    Logs
                  </Button>
                </>
              )}

              {selectedInstitutions.length > 0 && (
                <>
                  <Button
                    type="button"
                    color="primary"
                    className="waves-effect"
                    onClick={() => handleUpdateStatus("approve")}
                  >
                    Approve
                  </Button>
                  <Button
                    type="button"
                    color="danger"
                    className="waves-effect"
                    onClick={() => handleUpdateStatus("reject")}
                  >
                    Reject
                  </Button>
                </>
              )}
            </div>
          </div>

          <div className="institution-data-table table-responsive mt-4 mb-3 ">
            {loading ? (
              <DataTableLoader cols={10} />
            ) : (
              <>
                <Table className="table mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          onClick={toggleSelectAll}
                          checked={
                            selectedInstitutions.length ===
                            filteredInstitutionDetails.length
                          }
                        />
                      </th>
                      <th>#</th>
                      <th>Logo</th>
                      <th>Institution Name</th>
                      <th>Type</th>
                      <th>Year Established</th>
                      <th>
                        <span className="d-flex align-items-center gap-2 justify-content-center">
                          <span>Category</span>
                          <span
                            onClick={e => op.current.toggle(e)}
                            style={{ cursor: "pointer" }}
                          >
                            <i className="mdi mdi-filter" />
                          </span>
                          <OverlayPanel ref={op}>
                            <Input
                              type="select"
                              value={filterCategory}
                              onChange={e => {
                                setFilterCategory(e.target.value)
                                op.current.hide()
                              }}
                              style={{ width: "150px" }}
                            >
                              <option value="all">All</option>
                              {categoryOptions.map((category, index) => (
                                <option key={index} value={category.code}>
                                  {category.name}
                                </option>
                              ))}
                            </Input>
                          </OverlayPanel>
                        </span>
                      </th>
                      <th>UGC Approval</th>
                      <th>
                        <span className="d-flex align-items-center gap-2 justify-content-center">
                          <span>Verified Status</span>
                          <span
                            onClick={e => os.current.toggle(e)}
                            style={{ cursor: "pointer" }}
                          >
                            <i className="mdi mdi-filter" />
                          </span>
                        </span>
                        <OverlayPanel ref={os}>
                          <Input
                            type="select"
                            value={filterStatus}
                            onChange={e => {
                              setFilterStatus(e.target.value)
                              os.current.hide()
                            }}
                            style={{ width: "150px" }}
                          >
                            <option value="all">All</option>
                            <option value="approved">Approved</option>
                            <option value="rejected">Rejected</option>
                            <option value="pending">Pending</option>
                          </Input>
                        </OverlayPanel>
                      </th>
                      <th>Edit</th>
                      <th>View</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredInstitutionDetails && filteredInstitutionDetails.map((institution, index) => (
                      <tr
                        key={institution._id}
                        className="university-table-row"
                      >
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedInstitutions.includes(
                              institution._id,
                            )}
                            onClick={() => {
                              toggleSelection(institution._id)
                            }}
                          />
                        </td>
                        <th scope="row">{(page - 1) * limit + index + 1}</th>
                        <td>
                          {institution?.logo ? (
                            <div
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                toggleLogoModal(institution.logo.url)
                              }
                            >
                              <img
                                src={institution.logo.url}
                                alt={institution.logo.alt || "Institution Logo"}
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                  border: "1px solid #ddd",
                                }}
                              />
                            </div>
                          ) : (
                            <div
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                backgroundColor: "#f0f0f0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "12px",
                                color: "#888",
                                border: "1px solid #ddd",
                              }}
                            >
                              N/A
                            </div>
                          )}
                        </td>
                        <td>{institution.institutionName}</td>
                        <td>{institution.type}</td>
                        <td>{institution.yearEstablished}</td>
                        <td>{institution.category}</td>

                        <td>{institution.ugcApproval ? "Yes" : "No"} </td>

                        <td>
                          <span
                            className={`status ${institution.verifiedStatus.toLowerCase()}`}
                          >
                            {institution.verifiedStatus === "approved"
                              ? "Approved"
                              : institution.verifiedStatus === "rejected"
                                ? "Rejected"
                                : "Pending"}
                          </span>
                        </td>



                        <td>
                          <span
                            className="edit-institution"
                            onClick={() => {
                              navigate(
                                `/edit-institution/${institution?.institutionCode}`,
                                { state: institution },
                              )
                            }}
                          >
                            <i className="ion ion-md-create" />
                          </span>
                        </td>

                        <td>
                          <span
                            onClick={() => {
                              navigate(
                                `/view-institution/${institution?.institutionCode}`,
                                { state: institution },
                              )
                            }}
                            className="view-institution"
                          >
                            <i className="ion ion-md-eye" />
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="pagination-container d-flex align-items-center justify-content-end">
                  <Pagination>
                    <PaginationItem disabled={page <= 1}>
                      <PaginationLink
                        previous
                        onClick={() => setPage(page - 1)}
                      />
                    </PaginationItem>
                    {[...Array(Math.max(0, Math.min(3, totalPages)))].map(
                      (_, index) => (
                        <PaginationItem key={index} active={index + 1 === page}>
                          <PaginationLink onClick={() => setPage(index + 1)}>
                            {index + 1}
                          </PaginationLink>
                        </PaginationItem>
                      ),
                    )}

                    {totalPages > 6 && page > 3 && page < totalPages - 2 && (
                      <PaginationItem disabled>
                        <PaginationLink>...</PaginationLink>
                      </PaginationItem>
                    )}

                    {totalPages > 6 && page > 3 && page < totalPages - 2 && (
                      <PaginationItem active>
                        <PaginationLink onClick={() => setPage(page)}>
                          {page}
                        </PaginationLink>
                      </PaginationItem>
                    )}

                    {totalPages > 6 && page < totalPages - 2 && (
                      <PaginationItem disabled>
                        <PaginationLink>...</PaginationLink>
                      </PaginationItem>
                    )}

                    {totalPages > 3 &&
                      [...Array(Math.min(3, totalPages))].map((_, index) => {
                        const pageNumber = totalPages - 2 + index
                        return (
                          <PaginationItem
                            key={pageNumber}
                            active={pageNumber === page}
                          >
                            <PaginationLink onClick={() => setPage(pageNumber)}>
                              {pageNumber}
                            </PaginationLink>
                          </PaginationItem>
                        )
                      })}
                    <PaginationItem disabled={page >= totalPages}>
                      <PaginationLink next onClick={() => setPage(page + 1)} />
                    </PaginationItem>
                  </Pagination>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default InstitutionDataTable
